import React from 'react';
import VoiceLibraryContainer from '@src/containers/VoiceLibrary';

const VoiceLibraryPage = () => <VoiceLibraryContainer />;

export default VoiceLibraryPage;
